import(/* webpackMode: "eager" */ "/home/erodriguez/ca-global/node_modules/.pnpm/@tanstack+react-query-devtools@5.67.2_@tanstack+react-query@5.67.2_react@19.0.0__react@19.0.0/node_modules/@tanstack/react-query-devtools/build/modern/index.js");
;
import(/* webpackMode: "eager" */ "/home/erodriguez/ca-global/node_modules/.pnpm/next@15.2.1_@opentelemetry+api@1.9.0_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/GeistVF.woff\",\"variable\":\"--font-geist-sans\",\"weight\":\"100 900\"}],\"variableName\":\"geistSans\"}");
;
import(/* webpackMode: "eager" */ "/home/erodriguez/ca-global/node_modules/.pnpm/next@15.2.1_@opentelemetry+api@1.9.0_react-dom@19.0.0_react@19.0.0__react@19.0.0/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/GeistMonoVF.woff\",\"variable\":\"--font-geist-mono\",\"weight\":\"100 900\"}],\"variableName\":\"geistMono\"}");
;
import(/* webpackMode: "eager", webpackExports: ["NuqsAdapter"] */ "/home/erodriguez/ca-global/node_modules/.pnpm/nuqs@2.4.1_next@15.2.1_@opentelemetry+api@1.9.0_react-dom@19.0.0_react@19.0.0__react@19.0.0__react@19.0.0/node_modules/nuqs/dist/adapters/next/app.js");
;
import(/* webpackMode: "eager" */ "/home/erodriguez/ca-global/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/erodriguez/ca-global/src/app/provider-i18.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/erodriguez/ca-global/src/app/query-provider.tsx");
;
import(/* webpackMode: "eager" */ "/home/erodriguez/ca-global/src/components/ui/accordion.tsx");
;
import(/* webpackMode: "eager" */ "/home/erodriguez/ca-global/src/components/ui/autocomplete.tsx");
;
import(/* webpackMode: "eager" */ "/home/erodriguez/ca-global/src/components/ui/avatar.tsx");
;
import(/* webpackMode: "eager" */ "/home/erodriguez/ca-global/src/components/ui/calendar.tsx");
;
import(/* webpackMode: "eager" */ "/home/erodriguez/ca-global/src/components/ui/collapsible.tsx");
;
import(/* webpackMode: "eager" */ "/home/erodriguez/ca-global/src/components/ui/command.tsx");
;
import(/* webpackMode: "eager" */ "/home/erodriguez/ca-global/src/components/ui/context-menu.tsx");
;
import(/* webpackMode: "eager" */ "/home/erodriguez/ca-global/src/components/ui/data-table/data-table-toolbar.tsx");
;
import(/* webpackMode: "eager" */ "/home/erodriguez/ca-global/src/components/ui/data-table/data-table-view-options.tsx");
;
import(/* webpackMode: "eager" */ "/home/erodriguez/ca-global/src/components/ui/data-table/hooks/use-data-table.ts");
;
import(/* webpackMode: "eager" */ "/home/erodriguez/ca-global/src/components/ui/dialog.tsx");
;
import(/* webpackMode: "eager" */ "/home/erodriguez/ca-global/src/components/ui/drawer.tsx");
;
import(/* webpackMode: "eager" */ "/home/erodriguez/ca-global/src/components/ui/dropdown-menu.tsx");
;
import(/* webpackMode: "eager" */ "/home/erodriguez/ca-global/src/components/ui/form.tsx");
;
import(/* webpackMode: "eager" */ "/home/erodriguez/ca-global/src/components/ui/hover-card.tsx");
;
import(/* webpackMode: "eager" */ "/home/erodriguez/ca-global/src/components/ui/label.tsx");
;
import(/* webpackMode: "eager" */ "/home/erodriguez/ca-global/src/components/ui/multi-select.tsx");
;
import(/* webpackMode: "eager" */ "/home/erodriguez/ca-global/src/components/ui/popover.tsx");
;
import(/* webpackMode: "eager" */ "/home/erodriguez/ca-global/src/components/ui/scroll-area.tsx");
;
import(/* webpackMode: "eager" */ "/home/erodriguez/ca-global/src/components/ui/select.tsx");
;
import(/* webpackMode: "eager" */ "/home/erodriguez/ca-global/src/components/ui/separator.tsx");
;
import(/* webpackMode: "eager" */ "/home/erodriguez/ca-global/src/components/ui/sheet.tsx");
;
import(/* webpackMode: "eager" */ "/home/erodriguez/ca-global/src/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager" */ "/home/erodriguez/ca-global/src/components/ui/tabs.tsx");
;
import(/* webpackMode: "eager" */ "/home/erodriguez/ca-global/src/components/ui/toast.tsx");
;
import(/* webpackMode: "eager" */ "/home/erodriguez/ca-global/src/components/ui/tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EditorProvider"] */ "/home/erodriguez/ca-global/src/contexts/editor-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProjectProvider"] */ "/home/erodriguez/ca-global/src/contexts/project-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserProvider"] */ "/home/erodriguez/ca-global/src/contexts/user-provider.tsx");
